import { createContext } from "react";
import { ScoreMetadata } from "types";

const HyroxMetadataContext = createContext<ScoreMetadata[] | undefined>(undefined);
HyroxMetadataContext.displayName = "HyroxMetadataContext";

export default HyroxMetadataContext;
